<template>
	<div class="login-view-root">

		<!--    <div class="body-div layout-centered bg-img" style="" :style="{backgroundImage: 'url(' + require('@/assets/img/bg/8.jpg') + ')'}">-->
		<div class="body-div layout-centered bg-img">

			<!--    <div class="layout-centered bg-img" style="background-image:url('@/assets/img/bg/4.jpg')">-->


			<!-- Main Content -->
			<div class="main-content qw-row">

				<CoachLogoView custom-message="welcomes you to your secure personal portal."/>


				<div class="bg-white shadow-7 w-400 mw-100 p-5" @mouseup="clearFormValidationInternal()">
					<h4 class="mb-5">
						<span v-if="isLoginCoach">Coach Login</span>
						<span v-else>Login into your account</span>
					</h4>

					<el-form :model="form"
							 :rules="rules"
							 ref="mainForm"
							 @keypress.enter.native="submitForm()"
					>
						<el-form-item prop="email" class="form-group mb-4">
							<input type="text" class="form-control" name="email" v-model="form.email"
								   placeholder="Email">
						</el-form-item>

						<el-form-item prop="password" class="form-group mb-4 pt-2">
							<input type="password" class="form-control" name="password" v-model="form.password"
								   placeholder="Password">
						</el-form-item>


						<div class="form-group pt-2">
							<el-button class="w-100" :loading="isProgressShowing" type="primary"
									   @click="submitForm()">Login
							</el-button>
						</div>

						<div v-if="errorMessage" class="text-danger pt-3">
							{{errorMessage}}
						</div>
					</el-form>
					<div class="form-group flexbox pt-3">
						<!--                        <div class="custom-control custom-checkbox">-->
						<!--                            <input type="checkbox" class="custom-control-input" checked>-->
						<!--                            <label class="custom-control-label">Remember me</label>-->
						<!--                        </div>-->
						<div class="layout-spacer"></div>

						<router-link class="text-muted small-2" :to="forgotPasswordTo">Forgot password?</router-link>
<!--						<a class="text-muted small-2" href="recover">Forgot password?</a>-->
					</div>
					<!--                <div class="divider">Or Login With</div>-->
					<!--                <div class="text-center">-->
					<!--                    <a class="btn btn-circle btn-sm btn-facebook mr-2" href="#"><i class="fa fa-facebook"></i></a>-->
					<!--                    <a class="btn btn-circle btn-sm btn-google mr-2" href="#"><i class="fa fa-google"></i></a>-->
					<!--                    <a class="btn btn-circle btn-sm btn-twitter" href="#"><i class="fa fa-twitter"></i></a>-->
					<!--                </div>-->

					<span v-if="isLoginCoach" class="pt-3">
						<hr class="w-30">

						<p class="text-center text-muted small-2">Don't have an account? <router-link :to="registerPathParams">Register here</router-link></p>
					</span>
				</div>

			</div><!-- /.main-content -->

		</div>
	</div>
</template>


<script>


import BaseComponent from "@/core/components/BaseComponent.vue";
import CoachLogoView from "@/core/components/Controls/CoachLogoView.vue";

export default {
	components: {CoachLogoView},
	extends: BaseComponent,
	name: "LoginView",
	props:{
		isLoginCoach: Boolean
	},

	data() {
		return {
			coachProfileData: null,
			form: {
				email: "",
				password: "",
			},
			rules: {

				email: [
					{
						required: true,
						whitespace: false,
						message: 'Please provide email',
						trigger: 'validate'
					},
				],
				password: [
					{
						required: true,
						whitespace: false,
						message: 'Password is required',
						trigger: 'validate'
					},
				],

			},

		}
	},
	computed: {
		forgotPasswordTo(){
			return {
				name: this.isLoginCoach ? "RecoverCoach" : "Recover",
				params: this.$route.params,
				query: this.$route.query,
			}
		},
		registerPathParams(){
			return {
				name:'SignupCoach',
				params: this.$route.params,
				query: this.$route.query
			}
		}
	},

	async mounted(){
		this.$analyticManager.trackPageView({title:  this.isLoginCoach ? "Login coach page" : "Login page general"})
		this.$analyticManager.setCohortVisitParams()
		if(this.coachEmbeddedUid){
			this.coachProfileData = await this.$dataManager.apiGetUserProfilePublic({uid: this.coachEmbeddedUid})
		}
	},

	methods: {

		onFormValidated() {
			this.login()
		},

		clearFormValidationInternal(){
			this.errorMessage = ""
			this.clearFormValidation()
		},


		async login() {
			this.errorMessage = ''
			this.progressNonBlocking()
			try{
				await this.$authManager.login(this.form.email, this.form.password)
				let _ = this.$analyticManager.trackEvent("User logged in")
				this.go("CoachingProcessMainCoach")
			} catch(error){
				let msg = error.message
				console.error(error)
				if(error.code === "auth/user-not-found"
				|| error.code === "auth/wrong-password"){
					msg = "Incorrect email or password"
				}
				this.errorMessage = msg
			}
			this.hideProgress()
		},
	},


}
</script>

<style lang="scss">
@import "login-view";

</style>
